"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledParagraph = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const styled_system_1 = require("styled-system");
exports.StyledParagraph = styled_1.default.p `
  display: block;
  font-family: "Open sans", sans-serif;
  font-size: 16px;
  ${styled_system_1.border};
  ${styled_system_1.color};
  ${styled_system_1.flexbox};
  ${styled_system_1.layout};
  ${styled_system_1.space};
  ${styled_system_1.typography};
`;
